import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { environment } from '../../environments/environment';

interface iSolicitudes {
	Paginado: {
		NumeroPagina: number;
		NumeroRegistros: number;
	};
	Fecha_Actualizacion_Inincio?: string;
	Fecha_Actualizacion_Fin?: string;
	Convocatoria_ID?: number;
	Asesor_ID?: number;
	Coordinador_ID?: number;
}

interface iSolicitudProgreso {
	Convocatoria_ID?:number,
    Curp?: string
}

interface iSolicitudAsesor
{
	Asesor_ID:number,
	LstSolicitudes: number[]
}

@Injectable({
	providedIn: "root",
})
export class SolicitudesService {
	constructor (private http: HttpClient) {}

	listarSolicitudes (numeroPagina, numeroRegistros) {
		const Data = {
			Paginado:{
				NumeroPagina: numeroPagina,
				NumeroRegistros: numeroRegistros
			},
			Fecha_Actualizacion_Inincio:null,
			Fecha_Actualizacion_Fin:null,
			Convocatoria_ID:0,
			Asesor_ID:0,
			Coordinador_ID:0
			}
		return this.http.post<any>(`${environment.ip}/Solicitud/ListarSolicitudes`,	Data);
	}

	obtenersolicitudId (Tramite_ID:number) {
		return this.http.get<any>(`${environment.ip}/Solicitud/ObtenerSolicitud/${Tramite_ID}`);
	}

	// Consulta del preguardado
	obtenerSolicitudProgreso (Data?: iSolicitudProgreso) {
		return this.http.post<any>(`${environment.ip}/Solicitud/ObtenerSolicitudProgreso`,	Data);
	}

	// Crear y actualizar
	upsert (solicitud) {
		return this.http.post<any>(`${environment.ip}/solicitud/Upsert`,solicitud);
	}

	enviar(solicitud) {
		return this.http.post<any>(`${environment.ip}/solicitud/Enviar`,solicitud);
		//return this.http.post<any>(`http://fa7500ae2986.ngrok.io/api/solicitud/Enviar`,solicitud);
	}
	guardar(solicitud) {
		return this.http.post<any>(`${environment.ip}/solicitud/Guardar`,solicitud);
	}

	enviarSolicitudCorreccion(solicitud) {
		return this.http.put<any>(`${environment.ip}/solicitud/EnviarSolicitudCorreccion`,solicitud);
	}

	//Asignar solicitudes a asesor
	asignarSolicitudesAsesor (Data: iSolicitudAsesor) {
		return this.http.post<any>(`${environment.ip}/Solicitud/AsignarSolicitudes`,Data);
	}

	//lista de asesores
	listarAsesores () {
		return this.http.get<any>(`${environment.ip}/Solicitud/ListarAsesoresOtorgamiento`);
	}

	obtenerHorariosDisponibles(data) {
		return this.http.post<any>(`${environment.ip}/Solicitud/ObtenerHorariosDisponibles`, data)
		// return this.http.post<any>(`${environment.ip}/Solicitud/ObtenerHoras`, data);
	}

	enviarValidada(id) {
		return this.http.put<any>(`${environment.ip}/Solicitud/ValidarSolicitud?idSolicitud=${id}`,'')
	}

	agendarCita(data) {
		return this.http.post<any>(`${environment.ip}/Solicitud/AgendarCita`, data);
	}
	obtenerAgendaAsesor() {
		return this.http.get<any>(`${environment.ip}/Solicitud/ConsultaAgendaAsesor`);
	}

	establecerHorariosAsesor(data) {
		return this.http.post<any>(`${environment.ip}/Persona/EstablecerHorariosAsesor`, data)
	}

	establecerHorariosAsesorRango(data) {
		return this.http.post<any>(`${environment.ip}/Persona/EstablecerHorariosAsesorRango`, data)
	}

	establecerTiempoAtencion(data) {
		return this.http.put<any>(`${environment.ip}/Persona/EstablecerTiempoAtencion?tiempo=`, data)
	}

	obtenerHorariosAsesor() {
		return this.http.get<any>(`${environment.ip}/Persona/ObtenerHorariosAsesor`)
	}
	cargaInicialSolicitante(ID) {
		return this.http.get<any>(`${environment.ip}/Solicitud/CargaIncialAgenda/${ID}`);
	}

}
